import styled from 'styled-components'

export const Title = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
  align-items: center;
`

export const Actions = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp16};
  align-items: center;
`
